import * as services from '@api';
import { openBill } from '../navigate';
import { detail } from './';
import { PageStatusType } from '@stores/pagestore';
import { isJDiwork } from '@utils';
import { requiredValidate, getHoverRow, getDataSourceByAlias, mergeDetailCopyData } from '../utils';

/**
 * 复制
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  cardStoreKey: string， 默认值：cardStore
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 *  billNo: string， 默认值：params.billNo
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  beforeDetailHook: 详情请求前钩子
 *  afterDetailHook: 详情请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const copy = {
  async doAction(rootStore: any, options: any = {}) {
    requiredValidate.call(this, options, ['cardStoreKey']);
    const { dataSourceAlias = '', cardStoreKey = 'cardStore' } = options;
    const { utils = {}, pageStore = {} } = rootStore;
    const { params = {}, query = {} } = pageStore;
    const cardStore = rootStore.get(cardStoreKey);
    if (!cardStore) throw (new Error(`The CardStore[${cardStoreKey}] not found`));
    const [dataSource, dataSourceLevel] = getDataSourceByAlias(dataSourceAlias || cardStore?.dataSource, rootStore.dataSource);

    try {
      pageStore?.startLoading?.();
      const detailRes = await detail.call(this, rootStore, { ...options, writeBack: false });
      const copyRes = await services.copy({ params: {
        ...query,
        billnum: options.billNo || params.billNo,
        busiObj: options.busiObj || query.busiObj,
        datasource: dataSourceAlias || cardStore?.dataSource || '',
        id: options.billId || params.billId,
        initiator: 'COPY'
      }
      });
      // 合并详情&复制接口数据
      const mergeRes = mergeDetailCopyData(dataSource, detailRes.data, copyRes.data);
      // 数据回写
      cardStore.setValue(mergeRes); // detial、copy 合并数据
      // 重置状态
      cardStore.setUiState(PageStatusType.ADD);
      Object.assign(params, { initiator: 'COPY', billId: '', code: '' });
      utils.message.success(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8003C', '复制成功'));
      return mergeRes;
    } catch (err: any) {
      utils.message.danger(err?.message);
      return Promise.reject(err);
    } finally {
      pageStore?.endLoading?.();
    }
  }
}

/**
 * 复制行
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  billNo: string，跳转卡片页的billNo
 * }
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const copyByRow = {
  get isOperationLog() {
    const { type } = this.params;
    if (type === 'modal') {
      return true;
    } else if (type === 'tab' && isJDiwork()) {
      return false;
    } else {
      const { pageStore = {} } = this.rootStore;
      const { generalSetting = {} } = pageStore;
      return generalSetting.tabOpenMode !== 1;
    }
  },
  async doAction (rootStore: any, options: any = {}) {
    requiredValidate.call(this, options, ['billNo']);
    const [hoverRow, tableStore] = getHoverRow.apply(this, arguments);
    if (!hoverRow) throw (new Error(`The hoverRow not found`));
    return openBill.doAction.call(this, rootStore, {
      ...options,
      billNo: options.billNo,
      billId: hoverRow.getValue('id'),
      mode: 'add',
      initiator: 'COPY'
    });
  }
}